/** Recuperado del despliegue 2026-10-05. Conserva lógica y memoización originales. */
import {
  rec_JSXRuntime as JSXRuntime,
  rec_React as React,
} from "../../runtime/index.jsx";
export function Componente_TS_84_83(e, t) {
  return (
    <span
      key={t}
      className={`py-1 text-[10px] uppercase text-(--text)`}
      children={e}
    />
  );
}
